var React = require('react');

function ChannelsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 20V14L17.71 16.29L12.41 11H4V13H11.59L16.29 17.71L14 20H20ZM17.71 7.71L20 10V4H14L16.29 6.29L13.41 9.17L14.83 10.59L17.71 7.71Z"}));
}

ChannelsInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"black"};

module.exports = ChannelsInline;

ChannelsInline.default = ChannelsInline;
